import React from 'react';
import ReactApexChart from 'react-apexcharts'
import { miles } from '../utilits/statisticTools';

function Miles(props) {
    return (
        <div className='miles'>
            <h3><span>Miles</span> Statistics</h3>
            <ReactApexChart options={miles.options} series={miles.series} type="bar" height={350} />
        </div >
    );
}

export default Miles;